module.exports = __webpack_public_path__ + "img/a011_2.89242197.png";